import type { ComponentProps } from 'react'

import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Input } from '@/components/ui/input'

export default function PasswordInput({ className, ...props }: Omit<ComponentProps<'input'>, 'type'>) {
    const [visible, setVisible] = useState(false)

    return (
        <div className='relative'>
            <Input
                type={visible ? 'text' : 'password'}
                className={cn('pr-11', className)}
                {...props}
            />

            <button
                type='button'
                onClick={() => setVisible(current => !current)}
                aria-label={visible ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'}
                aria-pressed={visible}
                className='absolute top-1/2 right-1.5 flex size-8 -translate-y-1/2 items-center justify-center rounded-md text-muted-foreground transition-colors outline-none hover:bg-muted hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/25'
            >
                {visible ? <EyeOff className='size-4' /> : <Eye className='size-4' />}
            </button>
        </div>
    )
}
